<div class="page-header text-center" [style.background-image]="'url(' + image + ')'">
    <div [ngClass]="containerClass">
        <h1 class="page-title">{{ title }}<span>{{ subtitle }}</span></h1>
    </div>
</div>